// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"765":"production-management","820":"company-profile"}[chunkId] + "." + {"765":"ed1e3d1c","820":"3cad1859"}[chunkId] + ".js";
};